import { prop } from "../../decorators/property";
import { KeyParagraphQuoteModel } from "../../desktop/models/key-paragraph-quote";
import { KeyParagraphContentModel } from "../../desktop/models/key-paragraph-content";
import { backboneModelProperties } from "../../decorators/backbone-properties";

@backboneModelProperties({
    relations : [
        {
            type: Backbone.Many,
            key: "ContentPieces",
            relatedModel: KeyParagraphContentModel
        },
        {
            type: Backbone.Many,
            key: "Quotes",
            relatedModel: KeyParagraphQuoteModel
        }
    ], defaults: {
        ContentPieces: [],
        Quotes: []
    }
})
export class DisplayKeyParagraphModel extends Backbone.AssociatedModel {
    @prop() public ParagraphNumber: number;
    @prop() public Quotes: Backbone.Collection<KeyParagraphQuoteModel>;
    @prop() public ContentPieces: Backbone.Collection<KeyParagraphContentModel>;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/display-key-paragraph.ts